var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"dense":"","items":_vm.priceList,"label":_vm.label,"rules":_vm.rules},on:{"change":_vm.emitUpdate},model:{value:(_vm.price),callback:function ($$v) {_vm.price=$$v},expression:"price"}})}
var staticRenderFns = []

export { render, staticRenderFns }